import React from 'react';
import FabeSelect from "./FabeSelect.jsx";
import {personBgColors} from "./BookingForm.jsx";
import {getPrice} from "../util/price";

class BookingService extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            totalPrice: this.getTotalItemPrice(props.price.value),
            totalSalesPrice: this.getTotalItemPrice((props.salesPrice && props.salesPrice.value) || 0)
        }
    }

    getTotalItemPrice(price) {
        let totalPrice = parseFloat(price);
        this.props.extras.forEach(extra => {
            if (extra.checked) {
                totalPrice += parseFloat(extra.price);
            }
        });
        return getPrice(totalPrice);
    }

    toggleExpand() {
        this.setState(prevState => ({
            expanded: !prevState.expanded
        }));
    }

    extraChangeHandler(e, extra) {
        this.props.extraChangeHandler(e.target.checked, this.props.id, extra);
        this.setState(prevState => ({
            totalPrice: this.getTotalItemPrice(this.props.price.value),
            totalSalesPrice: this.getTotalItemPrice((this.props.salesPrice && this.props.salesPrice.value) || 0),
        }));
    }

    renderExtras() {
        return this.props.extras.map((item, index) => {
            return (
                <label key={index} className="checkbox">
                    <span className="checkbox__title">
                        {item.title} <span className="booking-service__extra">
                            {trans.currency_prepend}{item.price}{trans.extra_append}</span>
                    </span>
                    <input type="checkbox" defaultChecked={item.checked} onChange={(e) => this.extraChangeHandler(e, item)}/>
                    <span className="checkmark"></span>
                </label>
            );
        });
    }

    getPersonOptions() {
        if (this.props.clientCount <= 1) {
            return [];
        }
        const range = Array.apply(null, Array(this.props.clientsCount)).map(function (_, i) {return i;});
        return range.map((key) => {

            return {
                prefix: this.getPrefix(key),
                name: 'Person ' + (key + 1),
                value: key + 1
            }
        })
    }

    getPrefix(key) {
        const cx = 'rounded-full text-center mr-2 text-white inline-block w-5 h-5 leading-normal align-middle ' + personBgColors[key];
        return <div className={cx}>{key + 1}</div>
    }

    getSelectedPerson(value) {
        const selected = this.getPersonOptions().find((opt) => opt.value === value);
        return selected ? selected : { name: '', value: '' };
    }

    getPriceElement() {
        if (this.props.isOnSale) {
            return (
                <>
                    <div className="text-fifth-red">
                        <span className="booking-service__price">{this.state.totalSalesPrice} </span>
                        {this.props.price.append}
                    </div>
                    <div className="text-xs line-through">
                        <span className="booking-service__price">{this.state.totalPrice} </span>
                        {this.props.price.append}
                    </div>
                </>
            );
        } else {
            if (isNaN(this.state.totalPrice)) {
                return null;
            }
            return (
                <span className="booking-service__price">{this.state.totalPrice} {this.props.price.append}</span>
            );
        }
    }

    render() {
        return (
            <div className="booking-service react-collapse-item">
                <div className="booking-service__header react-collapse-header flex flex-wrap justify-between items-center react-collapse-toggle" onClick={() => this.toggleExpand()}>
                    <h3 className="booking-service__title flex-1 flex items-center">
                        {this.props.title}
                        {this.props.extras.length || this.props.description.length
                            ? <a className="md:hidden service-item__more"><i className="fas fa-angle-down"></i></a>
                            : null }

                        { this.props.extras.length || this.props.description.length
                        ?  <a className="hidden md:inline-block service-item__more">read more</a>
                        : null }
                    </h3>
                    <ul className="booking-service__details inline-block md:text-right">
                        {
                            this.props.duration.value
                            ? <li><span className="booking-service__duration">{this.props.duration.value}{this.props.duration.append}</span></li>
                            : ""
                        }

                        <li>
                            {this.getPriceElement()}
                        </li>
                    </ul>
                    <span onClick={this.props.removeHandler}><i className="booking-service__remove far fa-trash-alt"></i></span>
                </div>
                { this.props.extras.length || this.props.description.length ?
                    <div className={"react-collapse-content " + (this.state.expanded ? "expanded" : "")}>
                        <div className="react-collapse-content-inner">
                            <div className="booking-service__description" dangerouslySetInnerHTML={{__html: this.props.description}}>

                            </div>
                            <div className="booking-service__options">
                                { this.renderExtras() }
                            </div>
                        </div>
                    </div> : ''
                }

                {this.props.clientsCount > 1 && <div className="w-full flex items-baseline">
                    <div className="fabe-input flex flex-wrap person w-full md:w-1/4">
                        <div className="w-full">
                            <FabeSelect
                                placeholder={<>{this.getPrefix(this.props.person - 1)} {this.getSelectedPerson(this.props.person).name}</>}
                                options={this.getPersonOptions()}
                                changeHandler={(_value) => this.props.changeServicePerson(this.props.id, _value)}
                                value={this.props.person}
                            />
                        </div>
                        <i className="fas fa-angle-down"></i>
                    </div>
                    <div className="ml-6 text-pink text-sm underline hover:no-underline" onClick={this.props.duplicateItem}>
                        Add copy for another person
                    </div>
                </div>}
            </div>
        )
    }
}

export default BookingService;



// WEBPACK FOOTER //
// ./scripts/components/BookingService.jsx